import React from 'react'
import { TableProps } from 'antd/lib/table'

import { ColumnProps } from 'src/components/Ant/Table'
import { currencyMask } from 'src/components/Formik'
import { Table, Text } from 'src/components/Ant'
import { R2Data } from 'src/store/ducks/reports/types'

const columns: ColumnProps<R2Data>[] = [
  {
    align: 'center',
    dataIndex: 'service_name',
    key: 'service_name',
    render: (value: string) => <Text>{value}</Text>,
    title: 'web.report.2.data.service-name'
  },
  {
    align: 'right',
    dataIndex: 'quantity',
    key: 'quantity',
    render: (value: string) => <Text>{value}</Text>,
    title: 'web.report.2.data.quantity'
  },
  {
    align: 'right',
    dataIndex: 'total',
    key: 'total',
    render: (value: string) => (
      <Text>
        {
          currencyMask({
            formatStr: true,
            precision: 2,
            value
          }).maskedValue
        }
      </Text>
    ),
    title: 'web.report.2.data.total'
  }
]

function TableDetail({ ...props }: TableProps<R2Data>) {
  return (
    <Table
      {...props}
      className="table-striped table-sm"
      columns={columns}
      pagination={false}
    />
  )
}

export default TableDetail
